@for (item of userOtherNationalities.controls; track item; let i = $index) {
  <div class="row">
    <pr-input-column
      label="Une autre nationalité"
      [derrors]="derrors"
      style="width: 50%"
    >
      <mat-select
        [formControl]="userOtherNationalities.controls[i]"
        [attr.data-name]="'userOtherNationalities' + i"
      >
        @for (country of countries; track country) {
          <mat-option [value]="country.value">
            {{ country.value }}
          </mat-option>
        }
      </mat-select>
    </pr-input-column>
    @if (userOtherNationalities.length > 0) {
      @if (userOtherNationalities.controls[i].value) {
        <pr-button-confirm
          class="confirm"
          display="danger"
          clazz="pr-toolbar-button last"
          icon="delete_outline"
          title="Suppression"
          comment="Toute suppression est définitve, les données seront perdues."
          labelConfirm="Supprimer"
          labelCancel="Annuler"
          (onConfirm)="deleteFields(i)"
        >
          Êtes-vous sûr(e) de vouloir supprimer
          <em>“{{ userOtherNationalities.controls[i].value }}”</em>
        </pr-button-confirm>
      } @else {
        <pr-button
          display="danger"
          clazz="pr-toolbar-button last"
          icon="delete_outline"
          (onClick)="deleteFields(i)"
        ></pr-button>
      }
    }
  </div>
}

<pr-button-add
  type="button"
  display="neutral"
  (click)="addFields()"
  label="Ajouter une nationalité"
  rightIcon="+"
>
</pr-button-add>
